import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { GLOBAL_STATE, ROLE, ROLE_ALL, ROLE_CREATE, ROLE_DELETE, ROLE_LIST } from '../constants/actionTypes'

const rolesSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const roleSelector = createSelector(rolesSelector, data => data[ROLE])

export const roleListAllSelector = createSelector(rolesSelector, data => data[ROLE_ALL])

export const roleCreateSelector = createSelector(rolesSelector, data => data[ROLE_CREATE])

export const roleDeleteSelector = createSelector(rolesSelector, data => data[ROLE_DELETE])

export const roleListSelector = createSelector(rolesSelector, data => data[ROLE_LIST])
